
const successMessages = {
    DELETE_GOAL: 'Goal was successfully deleted!',
    CREATE_PAY_CODE_GLOBAL: 'Successfully added paycode type',
    EDIT_PAY_CODE_BY_ID_GLOBAL: 'Successfully updated paycode type',
    CREATE_OVERTIME_SETTINGS_GLOBAL: 'Successfully added overtime settings',
    EDIT_OVERTIME_SETTINGS_BY_ID_GLOBAL: 'Successfully updated overtime settings',
    DELETE_OVERTIME_SETTINGS_BY_ID_GLOBAL: 'Successfully deleted overtime settings',
    DELETE_SERVICE_BY_ID_GLOBAL: 'Successfully deleted service settings',
    DELETE_CREDENTIAL_BY_ID_GLOBAL: 'Successfully deleted credential',
    DELETE_DEPARTMENT_BY_ID_GLOBAL: 'Successfully deleted department',
    EDIT_CREDENTIAL_BY_ID_GLOBAL: 'Successfully updated credential',
    DELETE_JOB_BY_ID_GLOBAL: 'Successfully deleted job title',
    EDIT_JOB_BY_ID_GLOBAL: 'Successfully updated job title',
    CHANGE_NOTIFICATIONS: 'Notification settings saved.',
    EDIT_SERVICE_BY_ID_GLOBAL: 'Service type updated',
    CREATE_SERVICE_GLOBAL: 'Service type added',
    EDIT_DEPARTMENT_BY_ID_GLOBAL: 'Successfully updated department',
    CREATE_CREDENTIAL: 'Successfully added credential',
    CREATE_CREDENTIAL_GLOBAL: 'Successfully added credential',
    CREATE_DEPARTMENT_GLOBAL: 'Successfully added department',
    CREATE_JOB_GLOBAL: 'Successfully added job title',
    EDIT_CREDENTIAL_BY_ID: 'Successfully updated credential',
    DELETE_CREDENTIAL_BY_ID: 'Successfully deleted credential',
    DELETE_SIGNATURE: 'Signature Was Deleted',
    DELETE_STAFF_PAY_CODE: 'Paycode Was Deleted',
    REFRESH_ERRORS: 'Appointment issues was updated',
    CREATE_GLOBAL_NOTE: 'Successfully added note',
    EDIT_GLOBAL_NOTE: 'Successfully updated note',
    DELETE_GLOBAL_NOTE: 'Successfully delete note',
    CREATE_ADMIN: 'Successfully added staff',
    DELETE_STAFF_SIGNATURE: 'Signature removed.',
    CREATE_STAFF_SIGNATURE: 'Signature saved successfully.',
    EDIT_ADMIN_BY_ID: 'Successfully updated staff',
    CREATE_AVAILABILITY_SCHEDULE_GLOBAL: 'Successfully updated availability schedule',
    EDIT_FUNDING_SOURCE: 'Successfully updated Payer',
    CREATE_FUNDING_SOURCE: 'Successfully create Payer',
    CREATE_FUNDING_SOURCE_SERVICE_BY_ID: 'Successfully added service',
    EDIT_FUNDING_SOURCE_SERVICE: 'Successfully updated Service',
    CREATE_CLIENT: 'Successfully added client',
    DELETE_CLIENT: 'Successfully deleted client',
    EDIT_CLIENT: 'Successfully updated client',
    EDIT_CLIENT_CONTACT: 'Successfully updated contact',
    CREATE_CLIENT_CONTACT: 'Successfully added contact',
    DELETE_CLIENT_CONTACT: 'Successfully deleted contact',
    EDIT_CLIENT_ENROLLMENT: 'Successfully updated payer',
    DELETE_CLIENT_ENROLLMENT: 'Successfully deleted payer',
    CREATE_CLIENT_ENROLLMENT: 'Successfully added payer',
    EDIT_CLIENT_AUTHORIZATION: 'Successfully updated authorization',
    CREATE_CLIENT_AUTHORIZATION: 'Successfully added authorization',
    EDIT_CLIENT_AUTHORIZATION_SERV: 'Successfully updated service',
    CREATE_CLIENT_AUTHORIZATION_SERV: 'Successfully added service',
    DELETE_CLIENT_AUTHORIZATION: 'Successfully deleted authorization',
    DELETE_CLIENT_AUTHORIZATION_SERV: 'Successfully deleted Service',
    CREATE_EMPLOYMENT: 'Successfully added employment',
    EDIT_EMPLOYMENT: 'Successfully updated employment',
    CREATE_PAY_CODE: 'Successfully added pay code',
    EDIT_PAY_CODE: 'Successfully updated paycode',
    DELETE_STAFF_SERVICE: 'Successfully deleted service',
    CREATE_STAFF_SERVICE: 'Successfully added service',
    CREATE_ROLE: 'Role Was added',
    DELETE_ROLE: 'Role Was Deleted',
    DELETE_ROLE_PERMISSION: 'Role Permission was deleted',
    CREATE_MILEAGE: 'Successfully added mileage',
    EDIT_MILEAGE: 'Successfully updated Mileage',
    DELETE_MILEAGE: 'Successfully deleted Mileage',
    IS_CLINICIAN: 'Successfully changed Clinician',
    SET_STATUS: 'Successfully changed Status',
    CHANGE_FUNDING_SOURCE_STATUS: 'Successfully changed Status',
    CREATE_PLACE_GLOBAL: 'Successfully added place of service',
    CREATE_TIMESHEET: 'Successfully added timesheet',
    EDIT_PLACE_BY_ID_GLOBAL: 'Successfully updated place of service',
    DELETE_PLACE_BY_ID_GLOBAL: 'Successfully deleted place of service',
    CREATE_UPLOAD: 'Successfully uploaded file',
    DELETE_UPLOADS: 'Successfully deleted File',
    APPOINTMENT_REPEAT: 'Appointment repeat was updated',
    ASSIGN_ACCESS: 'Access was assigned',
    REMOVE_ACCESS: 'Access was deleted',
    CHANGE_PASSWORD_REQUEST: 'Password was updated',
    EDIT_TIMESHEET: 'Timesheet was updated',
    SET_APPOINTMENT_STATUS: 'Appointment status was updated',
    CHANGE_FUNDING_MODIFIER_STATUS: 'Modifier status was updated',
    CREATE_FUNDING_MODIFIER: 'Modifier was added',
    EDIT_FUNDING_MODIFIER: 'Modifier was updated',
    TERMINATE_CLIENT_ENROLLMENT: 'Payer was terminated',
    CHANGE_ADMIN_STATUS: 'Staff status was updated',
    EDIT_CLIENT_STATUS: 'Client status was updated',
    CHANGE_ENROLLMENT_TYPE: 'Enrolment type was updated',
    CANCEL_APPT: 'Appointments was cancelled',
    REINVITE_ADMIN: 'Staff was Reinvited',
    CHANGE_CALENDAR_STATUS: 'Calendar status was updated',
    GET_RECOVERY_LINK: 'Recovery link was sent',
    SEND_FORM: 'Your message was sent',
    CREATE_ADMIN_DETAILS: 'Staff details was updated',
    APPOINTMENT_FROM_TEMPLATE: 'Appointments was created',
    CREATE_PROCESS_PAYROLL: 'All selected payrolls have been successfully processed.',
    SUBMIT_CLAIM_OFFICE_ALLY:
        'Your claims are now being submitted to Office Ally. You will receive a confirmation once the submission is successful.',
    SUBMIT_CLAIM_MANUAL:
        'Your claims have been successfully downloaded. You will receive a confirmation once the submission is successful.',
    GENERATE_CLAIM: 'Your claims have been successfully Prepared.',
    CHANGE_APPT_UNITS: 'Appointment units was updated',
    RESEND_CLIENT_INVITE: 'An invitation has been sent successfully.',
    EDIT_STAFF_PASSWORD: 'Staff Password was updated',
    REQUEST_APPT_NOTE: 'Appointment note request sent successfully',
    REMIND_APPT_NOTE: 'Reminder for appointment note sent successfully',
    EDIT_RESOURCE_ACCESS: 'Folder access was updated',
    EDIT_FORM: 'Form was edited',
    CHECK_ELIGIBILITY: 'Eligibility was checked',
    CHANGE_CLAIM_STATUS: 'Status updated successfully',
    VERIFY_REMITTANCES: 'Claim was verified',
    EDIT_CLAIM_PAYMENT_INFO: 'Claim payment was edited',

    DISCONNECT_INTEGRATION: 'Clearinghouse status was updated',
    EDIT_INTEGRATION_CONNECTION: 'Clearinghouse details was updated',
    EDIT_COMPANY: 'Company information was updated',
    EDIT_GOAL_STATUS: 'Goal status was updated',
    CHANGE_SINGLE_TARGET_MASTERY: 'Target mastery was updated',
    CHANGE_TARGET_MASTERY: 'Target mastery was updated',
    CHANGE_GOAL_MASTERY: 'Goal mastery was updated',
    REFRESH_SESSION: 'Session was updated',

    CREATE_CLIENT_INTAKE_FORM: 'Client intake form sent successfully',

    ADD_PAYER_ENROLLMENT: 'Enrollment added successfully.',
    CHANGE_PAYER_ENROLLMENT_STATUS: 'Enrollment status was updated.',
    UN_CANCEL_APPT: 'Appointment successfully un-canceled',
    RESEND_INVITE_FORM: 'Intake form invitation resent successfully.',
    CLIENT_FORM_REVIEW: 'Client information saved successfully.',
    MARK_AS_SECONDARY_BILLING: 'Claim secondary billing status updated successfully.',
    APPEAL_SUBMITTED_CLAIM: 'Claim appeal status updated successfully.',
    CANCEL_CLAIM: 'Claim cancelled successfully.',
    REMOVE_APPT_FROM_CLAIM: 'Appointment removed from claim successfully.',
    DELETE_CLAIM: 'Claim deleted successfully.',
    // MARK_AS_READY_SECONDARY_BILLING: 'Secondary billing was updated successfully.',
    ADD_TARGET_MAINTENANCE_STEP: 'Target maintenance step was added successfully.',
    EDIT_TARGET_MAINTENANCE_STEP: 'Target maintenance step was updated successfully.',
    DELETE_TARGET_MAINTENANCE_STEP: 'Step removed from maintenance rule!',
    SINGLE_TARGET_FOLLOW_GOAL_CONFIG: 'Target maintenance configuration updated successfully.',
    SINGLE_TARGET_MASTERY_FOLLOW_GOAL: 'Target mastery configuration updated successfully.',
    CHANGE_MAINTENANCE_STEP: 'Target step changed successfully.',
    DELETE_REMITTANCE: 'Payment deleted successfully.',
    EDIT_ZOOM_STATUS: 'Zoom connection status updated successfully.',
    CHANGE_TELEHEALTH_STATUS: 'Telehealth status updated successfully.',
    EDIT_PROGRESS_REPORT: 'Progress report was updated successfully.',
    CREATE_PROGRESS_REPORT: 'Progress report was created successfully.',
    REMIND_APPT_SIGNATURE: 'Reminder for appointment signature sent successfully',
    MARK_REVIEWED_REMITTANCE: 'Remittance marked as reviewed successfully',
    SAVE_MANUAL_SESSION: 'Session data saved. Mastery has been updated.',
    AI_FORM_GENERATED: 'Template generated successfully. Review and edit anything before saving.',
    CREATE_WISHLIST_ITEM: 'Wishlist request submitted successfully.',
    EDIT_WISHLIST_ITEM: 'Wishlist request updated successfully.',
    DELETE_WISHLIST_ITEM: 'Wishlist request deleted successfully.',
    WISHLIST_COMMENT_POSTED: 'Comment posted successfully.',
    CLINICAL_SETTINGS_SESSION_GOALS_SAVED: 'Session goal setting updated successfully.',
    CLINICAL_SETTINGS_GOAL_ORDER_SAVED: 'Default goal order updated successfully.',
};

export const ToastSuccess = (success) => {
    return successMessages[success] || false;
};
